<template>
    <div class="wrapper">
        <section class="text" v-if="text">
            <h5>Id :  {{ text.id }}  -  TextId : {{ text.textId }}</h5>
            <br>
            <h3 v-if="!editionMode">«{{ text.content }}»</h3>
            <button type="button" v-if="!editionMode && ['PersonDetail', 'PersonReview'].indexOf($route.name) != -1" class="btn btn-lg pull-right record-button" @click="enableEdition">Editer</button>
            <br>
            <div v-if="['PersonDetail', 'PersonReview'].indexOf($route.name) != -1 && editionMode">
                <div class="col-md-11">
                    <bs-input type="textarea" v-model="textFormBuffer"></bs-input>
                </div>
                <div class="col-md-1">
                    <button type="button" class="btn btn-success col-md-12" @click="validateEdition">Valider</button>
                    <br>
                    <br>
                    <button type="button" class="btn btn-danger col-md-12" @click="cancelEdition">Annuler</button>
                </div>
            </div>
        </section>
        <section class="main-controls" v-if="$route.name != 'PersonReview'">
            <div ref="peakMeter" style="width: 5em; height: 20em; margin: 1em 0;" v-if="$route.name != 'PersonDetail'"></div>
            <div id="buttons">
                <button @click="startRecording" class="record-button" :style="isRecording ? 'background:red' : ''" :disabled="isRecording">Record</button>
                <button class="record-button stop" @click="endRecording()" :disabled="!isRecording">Stop</button>
            </div>
        </section>
        <section class="sound-clips">
            <div v-if="text">
                <div v-if="text.file">
                    <label>Son stocké : </label>
                    <article class="clip">
                        <p>Current time : {{ savedClip ? prepareTimeString(savedClip.currentTime) : 0 }}</p>
                        <div ref="waveformSaved"></div>
                        <button v-if="savedClip" class="btn pull-left record-button" @click="playPause(savedClip)">&#9658; / &#9208;</button>
                        <button class="btn record-button" @click="uploadSound(-1)">Valider</button>
                        <!-- <advancedControls :clip="savedClip" :eq="eqDefault"></advancedControls> -->
                    </article>
                </div>
            </div>
            <div v-if="clips.length && $route.name != 'PersonReview'">
                <hr style="margin:0.5em;">
                <label>Nouveau(x) son(s) : </label>
                <article class="clip" v-show="clip.show" v-for="(clip, index) in clipsList" :key="clip.url">
                    <p v-if="clip">Current time : {{ prepareTimeString(clip.currentTime) }}</p>
                    <div ref="waveform" style="margin:42px"></div>
                    <!-- <advancedControls :clip="clip" :eq="eqDefault"></advancedControls> -->
                    <div>
                        <button class="btn pull-left record-button" @click="playPause(clip)">&#9658; / &#9208;</button>
                        <button class="btn delete" @click="deleteSound(index)">Supprimer</button>
                        <button class="btn record-button" @click="uploadSound(index)">{{ text ? 'Valider' : 'Télécharger' }}</button>
                        <button class="btn record-button" v-if="$route.name == 'FreeRecord'" @click="uploadSound(index, true)">Envoyer</button>
                        <a v-if="!text" ref="filePlaceholder" href="" download hidden></a>
                    </div>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
    import WaveSurfer from 'wavesurfer.js';
    import WebAudioPeakMeter from 'web-audio-peak-meter';
    import vueSlider from 'vue-slider-component';
    import AdvancedControls from 'components/AdvancedControls';
    import { input as BsInput } from 'vue-strap'

    export default {
        components: {
            BsInput,
            vueSlider,
            AdvancedControls
        },
        computed: {
            clipsList: function ()  {
                return this.clips;
            }
        },
        methods: {
            enableEdition() {
                this.textFormBuffer = this.text.content;
                this.editionMode = true;
            },
            validateEdition()   {
                let textPatch = this.formMode == 'create' ? 'créé' : 'mis à jour';
                let successCallback = (id) => {
                    this.$store.commit('ALERT_DATA_UPDATED', {
                        text: 'Le texte a été mis à jour avec succès.',
                        type: 'success'
                    });

                    this.$store.dispatch("getPersonDetail", {
                        personId: this.$route.params.personId,
                        callbacks: {
                            success: (data) => {
                                this.$store.commit("CURRENT_PERSON_UPDATED", { data: data });
                                this.editionMode = false;
                                this.initSavedFile();
                            }
                        }
                    });
                };

                this.$store.dispatch('updateText', {
                    newText: Object.assign({}, this.text, {content: this.textFormBuffer}),
                    callbacks: { success: successCallback }
                });
            },
            cancelEdition() {
                this.editionMode = false;
            },
            initSavedFile: function() {
                this.$nextTick(function(){
                    if (this.text.file) {
                        let savedClip = {
                            times: [0.000, 0.000],
                            currentTime: 0,
                            duration: 0,
                            show: true,
                            advancedControls: false,
                            postRecorder: null,
                            streamDest: null,
                            file: null,
                            eqMaster: 0,
                            ws: WaveSurfer.create({
                                container: this.$refs.waveformSaved,
                                waveColor: 'violet',
                                progressColor: 'purple'
                            })
                        };

                        let backup = {filters: [], volume: 1, eqMaster: 0};
                        if (this.savedClip) {
                        //     // this.savedClip.advancedControls = false;
                        //     // this.savedClip.times = null;
                        //     // backup = {
                        //     //     filters: this.savedClip.ws.backend.filters,
                        //     //     volume: this.savedClip.ws.backend.gainNode.gain.value,
                        //     //     eqMaster: this.savedClip.eqMaster
                        //     // };
                        //     // this.savedClip.ws.backend.filters = [];
                            this.savedClip.ws.destroy();
                        //     // this.savedClip.ws = null;
                        }

                        savedClip.ws.on('audioprocess', function () {
                            savedClip.currentTime = savedClip.ws.getCurrentTime();
                        });
                        let self = this;
                        savedClip.ws.on('ready', function () {
                            let duration = savedClip.ws.getDuration();
                            savedClip.times[1] = duration;
                            savedClip.duration = duration;
                            if (self.$route.name == "PersonReview")   {
                                if (self.savedClip)  {
                                    savedClip.ws.backend.setFilters(backup.filters);
                                    savedClip.ws.backend.gainNode.gain.value = backup.volume;
                                    savedClip.eqMaster = backup.eqMaster;                                        
                                }   
                                savedClip.times = self.getLimits(savedClip);
                            }

                            self.getSourceAndApplyFilters(savedClip);
                            savedClip.advancedControls = true;
                            self.$emit('ready');                         
                            self.savedClip = savedClip;
                        });

                        savedClip.ws.load(this.soundUrl());
                    }
                    else {
                        this.$emit('ready');                         
                    }         
                });

            },
            isAudioBufferSourceNode: function(audioNode) {
                return (audioNode && audioNode.toString() === "[object AudioBufferSourceNode]");
            },
            onEnded(node, clip) {
                return function() {
                    if (clip.postRecorder && clip.postRecorder.state == 'recording')  {
                        clip.postRecorder.stop();
                    }
                    // this.stopWithRelease(clip);
                };
            },
            getInputNode(clip) {
                if (clip.ws.backend.filters && clip.ws.backend.filters.length > 0)    {
                    return clip.ws.backend.filters[0];
                }

                return clip.ws.backend.gainNode;
            },
            getRawSourceNode(clip) {
                let node = clip.ws.backend.ac.createBufferSource();
                node.loop = false;
                node.buffer = clip.ws.backend.buffer;
                return node;
            },
            getSourceNode(clip) {
                if (!!clip.ws.backend.source) {
                    let previousSourceNode = clip.ws.backend.source;
                //     // if (!!previousSourceNode.gainSuccessor) {
                //     //     previousSourceNode.gainSuccessor.gain.setValueAtTime(previousSourceNode.gainSuccessor.gain.value, clip.ws.backend.ac.currentTime);
                //     //     previousSourceNode.gainSuccessor.gain.linearRampToValueAtTime(0.0001, clip.ws.backend.ac.currentTime + 0.2);                        
                //     // }
                //     setTimeout(function() {
                        previousSourceNode.disconnect();
                //         if (!!previousSourceNode.gainSuccessor) {
                //             // clip.fadeNode.disconnect(previousSourceNode.gainSuccessor);
                //             previousSourceNode.gainSuccessor.disconnect();
                //         }
                //     }, 200);
                }

                let sourceNode = this.getRawSourceNode(clip);
                // sourceNode.gainSuccessor = clip.ws.backend.ac.createGain();
                // sourceNode.connect(clip.fadeNode);
                // clip.fadeNode.connect(sourceNode.gainSuccessor);
                // sourceNode.connect(sourceNode.gainSuccessor);
                // sourceNode.gainSuccessor.connect(clip.ws.backend.analyser);
                sourceNode.connect(clip.ws.backend.analyser);
                if (this.isAudioBufferSourceNode(sourceNode))   {
                    sourceNode.onended = this.onEnded(sourceNode, clip).bind(this);
                }

                return sourceNode;
            },
            // setAttack(clip) {
            //     let currentValue = clip.fadeNode.gain.value;
            //     clip.fadeNode.gain.cancelScheduledValues(clip.ws.backend.ac.currentTime);
            //     clip.fadeNode.gain.setValueAtTime(currentValue, clip.ws.backend.ac.currentTime);

            //     if (!clip.attack) {
            //         clip.fadeNode.gain.setValueAtTime(1.0, clip.ws.backend.ac.currentTime);
            //         return;
            //     }

            //     let remainingAttackTime = (1 - clip.fadeNode.gain.value) * clip.attack;
            //     clip.fadeNode.gain.setValueAtTime(clip.fadeNode.gain.value, clip.ws.backend.ac.currentTime);
            //     clip.fadeNode.gain.linearRampToValueAtTime(1, clip.ws.backend.ac.currentTime + remainingAttackTime);
            // },
            // stopWithRelease(clip)    {
            //     let stopSound = function() {
            //         return toString.call(clip.ws.backend.source.stop) === '[object Function]' ? clip.ws.backend.source.stop(0) : clip.ws.backend.source.disconnect();
            //     };
            //     let currentValue = clip.fadeNode.gain.value;
            //     clip.fadeNode.gain.cancelScheduledValues(clip.ws.backend.ac.currentTime);
            //     clip.fadeNode.gain.setValueAtTime(currentValue, clip.ws.backend.ac.currentTime);

            //     if (!clip.release) {
            //         stopSound();
            //         return;
            //     }

            //     let remainingReleaseTime = clip.fadeNode.gain.value * clip.release;
            //     clip.fadeNode.gain.setValueAtTime(clip.fadeNode.gain.value, clip.ws.backend.ac.currentTime);
            //     console.log(clip.fadeNode.gain.value);
            //     clip.fadeNode.gain.linearRampToValueAtTime(0.00001, clip.ws.backend.ac.currentTime + remainingReleaseTime);

            //     window.setTimeout(function() {
            //     console.log(clip.fadeNode.gain.value);
            //         stopSound();
            //     }, remainingReleaseTime * 1000);
            // },
            start(clip, start, end) {
                if (!clip.ws.backend.buffer) {
                    return;
                }

                const adjustedTime = clip.ws.backend.seekTo(start, end);

                start = adjustedTime.start;
                end = adjustedTime.end;

                clip.ws.backend.scheduledPause = end;

                clip.ws.backend.source.start(0, start, end - start);

                if (clip.ws.backend.ac.state == 'suspended') {
                    clip.ws.backend.ac.resume && clip.ws.backend.ac.resume();
                }

                clip.ws.backend.setState('playing');
            },
            prepareEqualizer(clip) {
                let filters = this.eqDefault.map(function (band, index) {
                    let filter = clip.ws.backend.ac.createBiquadFilter();
                    filter.type = band.type;
                    index += 3;
                    filter.gain.value = !!clip.ws.backend.filters[index] ? clip.ws.backend.filters[index].gain.value : 0;
                    filter.Q.value = 1;
                    filter.frequency.value = band.f;
                    return filter;
                });
                return filters;
            },
            getSourceAndApplyFilters(clip)  {
                clip.ws.backend.gainNode.gain.value = clip.ws.backend.gainNode.gain.value != this.defaultVolume ? clip.ws.backend.gainNode.gain.value : this.defaultVolume;
                clip.ws.backend.source = this.getSourceNode(clip);

                // let filters = [];
                // let highPassFilter = clip.ws.backend.ac.createBiquadFilter();
                // highPassFilter.type = "highpass";
                // highPassFilter.frequency.value = clip.ws.backend.filters[0] ? clip.ws.backend.filters[0].frequency.value : this.defaultHighPass.frequency;
                // highPassFilter.Q.value = clip.ws.backend.filters[0] ? clip.ws.backend.filters[0].Q.value : this.defaultHighPass.peak;
                // filters.push(highPassFilter);

                // let lowPassFilter = clip.ws.backend.ac.createBiquadFilter();
                // lowPassFilter.type = "lowpass";
                // lowPassFilter.frequency.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].frequency.value : this.defaultLowPass.frequency;
                // lowPassFilter.Q.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].Q.value : this.defaultLowPass.peak;
                // filters.push(lowPassFilter);

                // let bandPassFilter = clip.ws.backend.ac.createBiquadFilter();
                // bandPassFilter.type = "bandpass";
                // bandPassFilter.frequency.value = clip.ws.backend.filters[2] ? clip.ws.backend.filters[2].frequency.value : this.defaultBandPass.frequency;
                // bandPassFilter.Q.value = clip.ws.backend.filters[2] ? clip.ws.backend.filters[2].Q.value : this.defaultBandPass.peak;
                // filters.push(lowPassFilter);

                // let compressor = clip.ws.backend.ac.createDynamicsCompressor();
                // compressor.threshold.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].threshold.value : this.defaultCompressor.threshold;
                // compressor.knee.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].knee.value : this.defaultCompressor.knee;
                // compressor.ratio.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].ratio.value : this.defaultCompressor.ratio;
                // compressor.attack.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].attack.value : this.defaultCompressor.attack;
                // compressor.release.value = clip.ws.backend.filters[1] ? clip.ws.backend.filters[1].release.value : this.defaultCompressor.release;
                // filters.push(compressor);
                
                // filters = filters.concat(this.prepareEqualizer(clip));
                // clip.ws.backend.setFilters(filters);
            },
            playPause(clip) {
                if (clip.ws.isPlaying())   {
                    clip.ws.pause();
                    if (clip.postRecorder) {
                        clip.postRecorder.stop();
                    }                    
                }
                else    {
                    this.getSourceAndApplyFilters(clip);
                    this.start(clip, clip.times[0], clip.times[1]);
                }
            },
            getDuration(clip)   {
                if (clip.ws) {
                    return clip.ws.getDuration();
                }
                return 0;
            },
            prepareTimeString(seconds) {
                let hours = Math.trunc(seconds / 3600);
                let minutes = Math.trunc((seconds % 3600) / 60)
                let nseconds = Math.trunc(seconds % 60);
                let thousandths = Math.trunc((seconds % 1) * 1000);
                return ((hours + '').length == 1 ? '0' + hours : hours) + ':' + ((minutes + '').length == 1 ? '0' + minutes : minutes) + ':' + ((nseconds + '').length == 1 ? '0' + nseconds : nseconds) + '.' + thousandths;
            },
            startRecording()	{
                this.isRecording = true;
                this.mediaRecorder.start();
            },
            endRecording()	{
                this.isRecording = false;
                this.mediaRecorder.stop();
            },
            deleteSound(index)	{
                window.URL.revokeObjectURL(this.clips[index].url);
                this.clips[index].advancedControls = false;
                this.clips[index].blob = null;
                this.clips[index].times = null;
                if (this.clips[index].convertedFileURL)   {
                    window.URL.revokeObjectURL(this.clips[index].convertedFileURL);
                }
                this.clips[index].ws.backend.filters = [];
                this.clips[index].ws.destroy();
                this.clips[index].ws = null;
                this.clips[index].show = false;
                // delete this.clips[index].ws.container.children[0].children[1];
                // this.clips.splice(index, 1);
            },
            cleanSounds()   {
                this.clips.forEach(function(value, index, array) {
                    window.URL.revokeObjectURL(value.url);
                    value.blob = null;
                    value.ws = null;
                    if (value.convertedFileURL)   {
                        window.URL.revokeObjectURL(value.convertedFileURL);
                    }
                }, this);
                this.clips = [];
            },
            uploadSound(index, send)	{
                let clip = index == -1 ? this.savedClip : this.clips[index];

                let self = this;
                this.worker.onmessage = function(e){
                    clip.file = e.data;

                    if (!self.text && !send)    {
                        clip.convertedFileURL = window.URL.createObjectURL(clip.file);
                        self.$refs.filePlaceholder[index].href = clip.convertedFileURL;
                        self.$refs.filePlaceholder[index].download = self.getFilename();
                        self.$refs.filePlaceholder[index].click();
                    }
                    else {
                        let data = new FormData();
                        data.append('file', clip.file);
                        data.append('metadata', JSON.stringify({"start": clip.times[0], "end": clip.times[1]}));
                        let headers = self.$store.state.headers;
                        headers['Content-Type'] = 'multipart/form-data';
                        let url = self.text ? "/common/text/" + self.text.id + "/import" : "/common/free-record/send";
                        self.axios.post(self.$store.state.baseUrl + url, data, {"headers": headers, responseType: 'json'}).then((response) => {
                            if (response.data.success)  {
                                if (send)   {
                                    self.$emit('sendSuccess');
                                }
                                else {
                                    self.$store.dispatch('getPersonDetail', {
                                        personId: self.$route.name == "UserRecord" ? self.$store.state.user.currentUserPerson.id : self.$store.state.admin.currentPerson.id,
                                        callbacks: {
                                            success: (data) => {
                                                if (self.$route.name == "UserRecord")   {
                                                    self.$store.commit("CURRENT_USER_PERSON_UPDATED", data);
                                                }
                                                else if (["PersonReview", "PersonDetail"].indexOf(self.$route.name) != -1)  {
                                                    self.$store.commit("CURRENT_PERSON_UPDATED", {data: data});
                                                    if (self.$route.name == "PersonDetail")    {
                                                        self.$store.commit('ALERT_DATA_UPDATED', {
                                                                text: 'Le son a été enregistré avec succès.',
                                                                type: 'success'
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                                return true;
                            }
                            self.$emit('uploadFail');
                            return false;
                        }).catch((err) => {
                            if (self.text)  {
                                self.$emit('uploadFail');
                            }
                            else    {
                                if (send)   {
                                    self.$emit('sendFail');
                                }
                                else    {
                                    self.$emit('convertFail');
                                }
                            }
                            return false;
                        });
                        self.$nextTick(function() {
                            if (!send)  {
                                self.clips = [];
                                self.$emit('upload');
                            }
                        });
                    }
                };
                this.worker.postMessage({
                    command: 'init',
                    config: {
                        sampleRate: this.audioCtx.sampleRate
                    }
                });

                this.worker.postMessage({
                    command: 'record',
                    buffer: [
                        clip.ws.backend.buffer.getChannelData(0),
                        (clip.ws.backend.buffer.numberOfChannels == 1 ? clip.ws.backend.buffer.getChannelData(0) : clip.ws.backend.buffer.getChannelData(1))
                    ]
                });

                this.worker.postMessage({
                    command: 'exportMonoWAV',
                    type: 'audio/wav'
                });

                this.worker.postMessage({
                    command: 'clear'
                });
            },
            reset() {
                if (this.$refs.savedClip)   {
                    this.$refs.savedClip.currentTime = 0;
                }
                this.clips.forEach(function(clip, index, array)   {
                    this.$refs.newClip[index].currentTime = 0;
                }, this);
            },
            soundUrl()  {
                return process.env.API_URL.replace('/app_dev.php', '') + '/' + this.text.file + '?ts=' + Date.now(); 
            },
            getFilename()   {
                let date = new Date();
                return [date.getDate(), date.getMonth() + 1, date.getFullYear(), date.getHours(), date.getMinutes()].join('-') + ".wav";
            },
            getLimits(clip) {
                let start = -1;
                let end = 0;

                let data = clip.ws.backend.buffer.getChannelData(0);
                for (let i = 0; i <= data.length; i++) {
                    if (data[i] > 0.025) {
                        end = i / 44100;
                        if (start == -1)    {
                            start = end - (25 * end / 100);
                            start = start < 0 ? 0 : start;
                        }
                    }
                }

                let goodEnd = end + (end * 25 / 100);
                end = goodEnd > clip.duration ? clip.duration : goodEnd;
                return [start, end];
            }
        },
        props: ['text'],
        data: function()  {
            return {
                textFormBuffer: '',
                editionMode: false,
            	isRecording: false,
            	clips: [],
            	constraints: {
            		audio: true
            	},
            	chunks: [],
            	audioCtx: null,
            	canvasCtx: null,
            	mediaRecorder: null,
                lastTextId: null,
                savedClip: null,
                defaultVolume: 1,
                defaultHighPass: {frequency: 0, peak: 0.0001},
                defaultLowPass: {frequency: 22050, peak: 0.0001},
                defaultBandPass: {frequency: 11025, peak: 0.0001},
                defaultCompressor: {threshold: 0, knee: 30, ratio: 12, attack: 0.003, release: 0.25},
                eqDefault : [
                    {
                        f: 32,
                        type: 'lowshelf'
                    }, {
                        f: 64,
                        type: 'peaking'
                    }, {
                        f: 125,
                        type: 'peaking'
                    }, {
                        f: 250,
                        type: 'peaking'
                    }, {
                        f: 500,
                        type: 'peaking'
                    }, {
                        f: 1000,
                        type: 'peaking'
                    }, {
                        f: 2000,
                        type: 'peaking'
                    }, {
                        f: 4000,
                        type: 'peaking'
                    }, {
                        f: 8000,
                        type: 'peaking'
                    }, {
                        f: 16000,
                        type: 'highshelf'
                    }
                ],
                meterNode: null,
                worker: null,
                isReady: false
            };
        },
        created()  {
            this.worker = new Worker('static/js/recorderWorker.js');
        },
        mounted()	{
            navigator.getUserMedia = (navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia ||
                navigator.mediaDevices.getUserMedia ||
                navigator.msGetUserMedia);

            this.audioCtx = new (window.AudioContext || webkitAudioContext)();
            if (navigator.getUserMedia) {
                let self = this;
                navigator.getUserMedia(this.constraints,
                function(stream) {
                    self.mediaRecorder = new MediaRecorder(stream);
                    let sourceNode = self.audioCtx.createMediaStreamSource(stream);
                    self.mediaRecorder.onstop =  function(e)	{
                        let nblob = new Blob(self.chunks, {type: "octet/stream"});
                        self.chunks = [];
                        let newClip = {
                            url: window.URL.createObjectURL(nblob),
                            blob: nblob,
                            times: [0.000, 0.000],
                            currentTime: 0,
                            duration: 0,
                            show: true,
                            advancedControls: false,
                            postRecorder: null,
                            streamDest: null,
                            file: null,
                            eqMaster: 0 //,
                            // fadeNode: null,
                            // attack: 0.04,
                            // release: 0.04
                        };
                        self.clips.push(newClip);
                        self.$nextTick(function() {
                            let index = self.clips.length - 1;
                            let ws = WaveSurfer.create({
                                container: self.$refs.waveform[index],
                                waveColor: 'violet',
                                progressColor: 'purple',
                                responsive: true
                            });
                            ws.loadBlob(nblob);
                            ws.on('ready', function () {
                                newClip.ws = ws;
                                let duration = ws.getDuration();
                                newClip.times[1] = duration;
                                newClip.duration = duration;
                                // newClip.fadeNode = ws.backend.ac.createGain();
                                // newClip.fadeNode.gain.value = 0;

                                // newClip.times = self.getLimits(newClip);
                                self.getSourceAndApplyFilters(newClip);
                                self.clips[index] = newClip;
                            });
                            ws.on('audioprocess', function () {
                                newClip.currentTime = ws.getCurrentTime();
                            });
                        });
                    }

                    self.mediaRecorder.ondataavailable = function(e)	{
                      self.chunks.push(e.data);
                    }
                    if (["PersonDetail", "PersonReview"].indexOf(self.$route.name) == -1)   {
                            self.meterNode = WebAudioPeakMeter.createMeterNode(sourceNode, self.audioCtx);
                            WebAudioPeakMeter.createMeter(self.$refs.peakMeter, self.meterNode, {});
                    }
                },
                function(err) {
                    console.log('The following error occured: ' + err);
                });
            } else {
        		// console.log('getUserMedia not supported on your browser!');
        	}
            this.isReady = false;
            this.$nextTick(function() {
                if (["PersonReview", "UserRecord"].indexOf(this.$route.name) != -1) {
                    this.initSavedFile();
                }
            });
        },
        beforeDestroy() {
          delete this.mediaRecorder;
          this.audioCtx.close().then(function(){});
          delete this.audioCtx;
          delete this.canvasCtx;
        }
    };
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
}

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.text {
 text-align: center;
 padding: 1em;
}

.main-controls {
  padding: 1em 0;
}

canvas {
  width: 100%;
  height: 60px;
  display: block;
  margin-bottom: 0.5rem;
}

#buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#buttons button {
  padding: 1rem;
  width: calc(50% - 0.25rem);
}

.record-button {
  background: #0088cc;
  text-align: center;
  color: white;
  border: none;
  transition: all 0.2s;
  padding: 0.5rem;
}

button:hover, button:focus {
  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 1);
  background: #0ae;
}

button:active {
  box-shadow: inset 0px 0px 20px rgba(0,0,0,0.5);
}


/* Make the clips use as much space as possible, and
 * also show a scrollbar when there are too many clips to show
 * in the available space */
 .sound-clips {
  flex: 1;
  overflow: auto;
}

section, article {
  display: block;
}

.clip {
  padding-bottom: 3em;
}

audio {
  width: 100%;
  display: block;
  margin: 1rem auto 0.5rem;
}

.clip p {
  display: inline-block;
}

.clip button{
  float: right;
  margin: 0.2em;
}
/*
.clip button .left{
  float: left;
  margin: 0.2em;
}*/

button.delete {
  background: red;
}

/* Cursor when clip name is clicked over */

.clip p {
  cursor: pointer;
}

/* Adjustments for wider screens */
@media all and (min-width: 800px) {
  /* Don't take all the space as readability is lost when line length
  goes past a certain size */
  .wrapper {
    width: 90%;
    max-width: 1000px;
    margin: 0 auto;
}
}
</style>
